import { Button } from 'Components/ui'
import { Column } from 'Components/Grid'
import styled from 'styled-components'

export const ButtonForm = styled(Button)`
  margin-top: 0 !important;
  height: 38px;
  width: fit-content;
  padding: 10px 22px;
  margin: 0 !important;
  &.full {
    width: 100%;
  }
  &.max-content {
    width: max-content;
  }
  &.center {
    justify-content: center;
  }
  ${({ gray }) =>
    gray && `
      background: var(--vo-cloud) !important;
      color: var(--vo-slate) !important;
      border: 1px solid var(--vo-steel) !important;
      box-shadow: none !important;
    `}
`

export const TitleForm = styled(Column)`
  font-family: var(--font-primary);
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  align-items: center;
  font-feature-settings: 'liga' off;
  color: var(--vo-ink);
  margin-bottom: 16px;
`
